import { request } from '../request'
import { GetPlanTaskList } from './plan-list'

// 获取任务列表
export interface GetTaskList extends Omit<GetPlanTaskList, 'task_type'> {
  protect_status?: string //保护结果
  result_status?: string
  task_id?: string
}
export const getTaskList = (data: GetTaskList) =>
  request('/portal/verify/dataProtection/resultList', {
    params: data,
  })

// 删除子任务
export interface DeleteTask {
  result_id_list: string[]
}
export const deleteTask = (data: DeleteTask) =>
  request('/portal/verify/dataProtection/batchDeleteResult', {
    method: 'DELETE',
    data,
  })

// 获取安全域列表
export const getBizAreaList = () => request('/portal/verify/dataProtection/resultBizAreaList')

//停止任务
export const stopTask = data =>
  request('/portal/verify/dataProtection/stopTask', {
    method: 'post',
    data,
  })

// 任务复测
export const retestTask = data =>
  request('/portal/verify/dataProtection/taskReExec', {
    method: 'post',
    data,
  })

// 删除主任务
export const deleteMainTask = (taskIds: string[]) =>
  request('/portal/verify/dataProtection/tasks', {
    method: 'post',
    data: { taskIds },
  })

// 获取任务列表
export const getMainTaskList = (data: any) =>
  request('/portal/verify/dataProtection/tasks', {
    params: data,
  })

// 获取任务执行列表
export const getTaskExecList = (data: any) =>
  request('/portal/verify/dataProtection/task/executions', {
    params: data,
  })

// 获取任务详情
export const getTaskDetail = (taskId: string) =>
  request(`/portal/verify/dataProtection/tasks/${taskId}`)

// 获取任务详情用例状态列表
export const getTaskDetailUseCaseStatus = data =>
  request(`/portal/v1/waf/task_results/${data.resultId}/case`)

// 任务结果 根据用例状态统计用例数
export const getTaskDetailUseCaseCount = data =>
  request(`/portal/v1/waf/task_results/${data.resultId}/case/count`)
